// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeatureFlagsDTOAPIModel
 */
export interface FeatureFlagsDTOAPIModel {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagsDTOAPIModel
     */
    allDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagsDTOAPIModel
     */
    verificationDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagsDTOAPIModel
     */
    invoiceDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagsDTOAPIModel
     */
    withdrawalDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlagsDTOAPIModel
     */
    demoDisabled: boolean;
}

export function FeatureFlagsDTOAPIModelFromJSON(json: any): FeatureFlagsDTOAPIModel {
    return FeatureFlagsDTOAPIModelFromJSONTyped(json, false);
}

export function FeatureFlagsDTOAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureFlagsDTOAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allDisabled': json['AllDisabled'],
        'verificationDisabled': json['VerificationDisabled'],
        'invoiceDisabled': json['InvoiceDisabled'],
        'withdrawalDisabled': json['WithdrawalDisabled'],
        'demoDisabled': json['DemoDisabled'],
    };
}

export function FeatureFlagsDTOAPIModelToJSON(value?: FeatureFlagsDTOAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AllDisabled': value.allDisabled,
        'VerificationDisabled': value.verificationDisabled,
        'InvoiceDisabled': value.invoiceDisabled,
        'WithdrawalDisabled': value.withdrawalDisabled,
        'DemoDisabled': value.demoDisabled,
    };
}


